import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Settings } from 'lucide-react';

const ease = [0.25, 0.1, 0.25, 1] as const;

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="border-t border-border bg-background">
      <div className="content-width px-5 md:px-8 py-16 md:py-24 text-center">
        <motion.h3
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-30px' }}
          transition={{ duration: 0.5, ease }}
          className="font-display text-2xl md:text-3xl text-foreground tracking-wide mb-2"
        >
          BROOKLYN STUDIO
        </motion.h3>
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, margin: '-30px' }}
          transition={{ duration: 0.5, ease, delay: 0.06 }}
          className="text-ui text-xs text-muted-foreground tracking-wider-ui uppercase mb-6"
        >
          {t('brooklyn.footer.tagline')}
        </motion.p>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, margin: '-30px' }}
          transition={{ duration: 0.5, ease, delay: 0.12 }}
          className="text-ui text-[10px] text-muted-foreground/60 tracking-wider-ui uppercase mb-10"
        >
          {t('brooklyn.footer.cities')}
        </motion.p>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, margin: '-30px' }}
          transition={{ duration: 0.5, ease, delay: 0.18 }}
          className="flex items-center justify-center gap-8 text-[10px] text-muted-foreground/40 tracking-wide-ui uppercase"
        >
          <span>{t('brooklyn.footer.copy')}</span>
          <a
            href="https://www.instagram.com/brooklynstudio.global/"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-foreground transition-colors duration-300"
          >
            {t('brooklyn.footer.instagram')}
          </a>
        </motion.div>

        <div className="mt-12 flex justify-center">
          <Link
            to="/admin/candidaturas"
            className="text-muted-foreground/20 hover:text-muted-foreground/40 transition-colors duration-300"
            title="Admin"
          >
            <Settings className="w-3 h-3" />
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
